import { nanoid } from 'nanoid';

const projects = [

  {
    id: nanoid(),
    title: 'Annotation Tools',
    img: '/imgs/labelling.jpg',
    desc: "A Data Annotation Tool built using Reactjs and Python renders millions of points",
    technologies: ['React.js', 'TailwindCSS', 'Redux'],
    github: 'https://github.com/xtreme1-io/xtreme1',
    live: 'https://www.deepen.ai/',
  },
  {
    id: nanoid(),
    title: 'Healthcare Portal',
    img: '/imgs/projects/hospitalManagement.png',
    desc: "Developed a comprehensive web application for managing hospital operations",
    technologies: ['React.js', 'TailwindCSS', 'Redux'],
    github: 'https://github.com/khvr000',
    live: 'http://hospital-management-new.s3-website.ap-south-1.amazonaws.com/dashboard',
  },
  {
    id: nanoid(),
    title: 'Medicare Hub',
    img: '/imgs/projects/healthCarePortal.webp',
    desc: 'A user interface designed to digitize the administrative processes of a hospital',
    technologies: ['React.js', 'TypeScript', 'TailwindCSS'],
    github: 'https://github.com/khvr000',
    live: 'https://sridevichandra.in/',
  },
  {
    id: nanoid(),
    title: 'Netflix-GPT',
    img: '/imgs/projects/netflixClone.png',
    desc: 'A fully responsive web application designed to replicate the core functionalities of Netflix',
    technologies: ['React.js', 'TypeScript', 'MantineUI'],
    github: 'https://github.com/khvr000',
    live: 'https://netflix-gpt-3ae3b.web.app/',
  },
 
 
];

const skills = [
  {
    icon: 'javascript',
    title: 'JavaScript',
  },
  {
    icon: 'python',
    title: 'Python',
  },
  {
    icon: 'react',
    title: 'React.js',
  },
  {
    icon: 'nextjs',
    title: 'Next.js',
  },
  {
    icon: 'aws',
    title: 'AWS',
  },
  {
    icon: 'redux',
    title: 'Redux',
  },
  {
    icon: 'nodejs',
    title: 'Node.js',
  },
  {
    icon: 'typescript',
    title: 'TypeScript',
  },
  {
    icon: 'mongodb',
    title: 'MongoDB',
  },
  {
    icon: 'expressjs',
    title: 'Express.js',
  },
  {
    icon: 'dynamodb',
    title: 'DynamoDB',
  },
  {
    icon: 'tailwindcss',
    title: 'TailwindCSS',
  },
  {
    icon: 'django',
    title: 'Django',
  },
  {
    icon: 'webpack',
    title: 'Webpack',
  },
  {
    icon: 'babel',
    title: 'Babel',
  },
  {
    icon: 'git',
    title: 'Git',
  },
  {
    icon: 'github',
    title: 'Github',
  },
  {
    icon: 'html',
    title: 'HTML',
  },
  {
    icon: 'css',
    title: 'CSS',
  },
];


export const data = { projects, skills };
